import { GameConstants } from "./../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { BattleManager } from "../BattleManager";
import { AudioManager } from "../../../AudioManager";

export class SpecialAttacks extends Phaser.GameObjects.Container {

    private suicideAttackButton: Phaser.GameObjects.Image;
    private suicideAttackTimer: Phaser.GameObjects.Graphics;
    private freezeAttackButton: Phaser.GameObjects.Image;
    private freezeAttackTimer: Phaser.GameObjects.Graphics;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.freezeAttackTimer = new Phaser.GameObjects.Graphics(this.scene);
        this.freezeAttackTimer.setPosition(-60, GameConstants.GAME_HEIGHT - 60);
        this.freezeAttackTimer.scaleX = this.scene.sys.game.device.os.desktop ? 1 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;
        this.add(this.freezeAttackTimer);

        this.freezeAttackButton = new Phaser.GameObjects.Image(this.scene, -60, GameConstants.GAME_HEIGHT - 60, "texture_atlas_1", "btn_skill_slow_idle");
        this.freezeAttackButton.setInteractive();
        this.freezeAttackButton.scaleX = this.scene.sys.game.device.os.desktop ? 1 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;
        this.freezeAttackButton.on("pointerup", () => { 
            this.onClickFreezeAttack(); 
        });
        this.freezeAttackButton.on("pointerdown", () => {
            this.freezeAttackButton.setFrame("btn_skill_slow_pressed");
        });
        this.freezeAttackButton.on("pointerout", () => { 
            if (this.freezeAttackButton.input.enabled) {
                this.freezeAttackButton.setFrame("btn_skill_slow_idle");
            }
        });
        this.freezeAttackButton.on("pointerover", () => { 
            this.freezeAttackButton.setFrame("btn_skill_slow_over");
        });
        this.add(this.freezeAttackButton);

        this.suicideAttackTimer = new Phaser.GameObjects.Graphics(this.scene);
        this.suicideAttackTimer.setPosition(60, GameConstants.GAME_HEIGHT - 60);
        this.suicideAttackTimer.scaleX = this.scene.sys.game.device.os.desktop ? 1 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;
        this.add(this.suicideAttackTimer);

        this.suicideAttackButton = new Phaser.GameObjects.Image(this.scene, 60, GameConstants.GAME_HEIGHT - 60, "texture_atlas_1", "btn_skill_pig_idle");
        this.suicideAttackButton.setInteractive();
        this.suicideAttackButton.scaleX = this.scene.sys.game.device.os.desktop ? 1 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;
        this.suicideAttackButton.on("pointerup", () => { 
            this.onClickSuicideAttack(); 
        });
        this.suicideAttackButton.on("pointerdown", () => {
            this.suicideAttackButton.setFrame("btn_skill_pig_pressed");
        });
        this.suicideAttackButton.on("pointerout", () => { 
            if (this.suicideAttackButton.input.enabled) {
                this.suicideAttackButton.setFrame("btn_skill_pig_idle");
            }
        });
        this.suicideAttackButton.on("pointerover", () => {
            this.suicideAttackButton.setFrame("btn_skill_pig_over");
        });
        this.add(this.suicideAttackButton);

        if (!GameVars.gameData.specialAttacks[0]) {
            this.freezeAttackTimer.visible = false;
            this.freezeAttackButton.visible = false;
        }

        if (!GameVars.gameData.specialAttacks[1]) {
            this.suicideAttackTimer.visible = false;
            this.suicideAttackButton.visible = false;
        }
    }

    public update(time: number, delta: number): void {

        if (BattleManager.anutoEngine.suicideSoldierCoolingDown) {

            let angle = (BattleManager.anutoEngine.suicideSoldierCooldownCounter / GameConstants.SUICIDE_ATTACK_COOLDOWN_TICKS) * 360 - 90;

            this.suicideAttackTimer.visible = true;
            this.suicideAttackTimer.clear();
            this.suicideAttackTimer.fillStyle(0x21E442);
            this.suicideAttackTimer.slice(0, 0, 55, Phaser.Math.DegToRad(-90), Phaser.Math.DegToRad(angle));
            this.suicideAttackTimer.fillPath();
        } else {
            this.suicideAttackTimer.visible = false;
        }

        if (BattleManager.anutoEngine.freezeAttackCoolingDown) {

            let angle = (BattleManager.anutoEngine.freezeAttackCooldownCounter / GameConstants.FREEZE_ATTACK_COOLDOWN_TICKS) * 360 - 90;

            this.freezeAttackTimer.visible = true;
            this.freezeAttackTimer.clear();
            this.freezeAttackTimer.fillStyle(0x21E442);
            this.freezeAttackTimer.slice(0, 0, 55, Phaser.Math.DegToRad(-90), Phaser.Math.DegToRad(angle));
            this.freezeAttackTimer.fillPath();
        } else {
            this.freezeAttackTimer.visible = false;
        }
    }

    public onSuicideSoldierAvailable(): void {

        this.suicideAttackButton.setFrame("btn_skill_pig_idle");
        this.suicideAttackButton.input.enabled = true;

        this.suicideAttackButton.setScale(.4);

        this.scene.tweens.add({
            targets: this.suicideAttackButton,
            scaleY: 1,
            scaleX: this.scene.sys.game.device.os.desktop ? 1 : ((1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX),
            ease: Phaser.Math.Easing.Bounce.Out,
            duration: 250
        });

        if(!GameVars.battleOver) {
            AudioManager.playSound("charged_attack");
        }
    }

    public onFreezeAttackAvailable(): void {

        this.freezeAttackButton.setFrame("btn_skill_slow_idle");
        this.freezeAttackButton.input.enabled = true;

        this.freezeAttackButton.setScale(.4);

        this.scene.tweens.add({
            targets: this.freezeAttackButton,
            scaleY: 1,
            scaleX: this.scene.sys.game.device.os.desktop ? 1 : ((1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX),
            ease: Phaser.Math.Easing.Bounce.Out,
            duration: 250
        });

        if(!GameVars.battleOver) {
            AudioManager.playSound("charged_attack");
        }
    }

    public onClickFreezeAttack(): void {

        this.freezeAttackTimer.visible = true;
        this.freezeAttackButton.visible = true;

        AudioManager.playSound("tar_wave");

        this.freezeAttackButton.setFrame("btn_skill_slow_disabled");
        this.freezeAttackButton.input.enabled = false;

        BattleManager.launchFreezeAttack();
    }

    public onClickSuicideAttack(): void {

        this.suicideAttackTimer.visible = true;
        this.suicideAttackButton.visible = true;

        AudioManager.playSound("pig_squeal");
        
        this.suicideAttackButton.setFrame("btn_skill_pig_disabled");
        this.suicideAttackButton.input.enabled = false;

        BattleManager.launchSuicideAttack();
    }
}
